import { Component } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AuthActions } from '../../../../core/auth/actions/auth.actions';
import { AuthSelectors } from '../../../../core/auth/selectors/auth.selectors';
import { NavbarActions } from '../../../../core/nav-bar/actions/nav-bar.actions';
import { NavbarSelectors } from '../../../../core/nav-bar/selectors/nav-bar.selectors';
import { MainNavigationActions } from '../../../../core/router/actions/main-navigation.action';
import { BaseAppState } from '../../../../core/store/reducers';
import { UserNavigationActions } from '../../../../core/users/actions/user-ui-navigation.actions';

@Component({
  selector: 'app-menu-overlay',
  templateUrl: './menu-overlay.component.html',
  styleUrls: ['./menu-overlay.component.scss'],
})
export class MenuOverlayComponent {
  public isMenuOpen$ = this.store.select(NavbarSelectors.getIsHamburgerMenuOpen);
  public isAdmin$ = this.store.pipe(select(AuthSelectors.getIsAdmin));

  constructor(private store: Store<BaseAppState>) {}

  public handleUsersOverviewClick(): void {
    this.store.dispatch(UserNavigationActions.goToUserList());
    this.toggleMenu();
  }

  public handleProfileClick(): void {
    this.store.dispatch(MainNavigationActions.goToProfile());
    this.toggleMenu();
  }

  public handleAdminAreaClick() {
    this.store.dispatch(MainNavigationActions.goToAdminArea());
    this.toggleMenu();
  }

  public handleStatisticsOverviewClick() {
    this.store.dispatch(MainNavigationActions.goToStatisticsOverview());
    this.toggleMenu();
  }

  public handleLogoutClick(): void {
    this.store.dispatch(AuthActions.logout());
  }

  private toggleMenu() {
    this.store.dispatch(NavbarActions.toggleHamburgerMenu());
  }
}
